import Line from './line';

export default class LineEdit extends Line {
    constructor(map, data, changeGeofencePoints) {
        super(map, data, null);
        this.changeGeofencePoints = changeGeofencePoints;
        let wght = this.getLineWidth(this.radius);
        this.setStyle({ weight: wght, opacity: 0.3 });
        map.on('editable:drawing:end', () => {
            this.changeGeofencePoints(this.getCoords());
        });
        map.on('editable:dragend', () => {
            this.changeGeofencePoints(this.getCoords());
        });
        map.on('editable:editing', () => {
            this.changeGeofencePoints(this.getCoords());
        });
        this.on("remove", () => {
            this.map.off('editable:drawing:start');
            this.map.off('editable:drawing:end');
            this.map.off('editable:dragstart');
            this.map.off('editable:dragend');
        });
        document.onkeydown = (evt) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            } else {
                isEscape = (evt.keyCode === 27);
            }
            if (isEscape) {
                this.map.editTools.commitDrawing();
            }
        };
    }

    startEdit() {
        if (this.id === '0') {
            this.editable = this.enableEdit().newShape(null);
        }
        else {
            this.editable = this.enableEdit();
        }
    }

    updateData(data) {
        this.name = data.name;
        this.unbindTooltip();
        if (this.name) {
            this.bindTooltip(this.name);
        }
        if (this._latlngs.length > 0) {
            var color = data.dataForMap.color;
            this.radius = data.dataForMap.radius;
            var weight = this.getLineWidth(this.radius);
            this.setStyle({ color, weight, opacity: 0.3 });
        }
    }

    onOverLine() { }
    onOutLine() { }
    onClick() { }
}   
